const SECTION_TYPES = {
  ORIGINAL: 'OT',
  STANDARD: 'ST',
};

const PLATFORMS = {
  IOS: 'ios',
  ANDROID: 'android',
};

const GENRES = [
  {
    type: 'thriller',
    label: '스릴러',
  },
  {
    type: 'romance',
    label: '로맨스',
  },
  {
    type: 'horror',
    label: '호러',
  },
  {
    type: 'sf',
    label: '공상과학',
  },
  {
    type: 'comic',
    label: '코믹',
  },
  {
    type: 'drama',
    label: '드라마',
  },
];

const STORY_TYPES = {
  STANDARD: {
    type: 'standard',
    label: '표준',
  },
  ORIGINAL: {
    type: 'original',
    label: '오리지널',
  },
};

const STORY_SALE_TYPES = {
  STANDARD: 'S',
  STANDARD_WAITFREE: 'SWF',
  AD_WAITFREE: 'ADWF',
};

const PURCHASE_TYPES = {
  WAITFREE: 'waitfree',
  SHOW_AD: 'show_ad',
  RENTAL: 'rental',
  POSSESSION: 'possession',
  REMOVE_AD: 'remove_ad',
  PREVIEW: 'preview',
};

const EPISODE_STATUSES = {
  PRIVATE: {
    type: 'private',
    label: '비공개',
  },
  REVIEW: {
    type: 'review',
    label: '검수중',
  },
  REJECT: {
    type: 'reject',
    label: '반려',
  },
  PUBLIC: {
    type: 'public',
    label: '공개',
  },
  BOOKED_PUBLIC: {
    type: 'booked_public',
    label: '예약',
  },
};

const MARKET_ITEM_TYPES = {
  ETC: {
    type: 'etc',
    label: '아이템',
  },
  USER_PICTURE: {
    type: 'skin_user_picture',
    label: '프로필',
  },
  PROFILE_BACKGROUND: {
    type: 'skin_profile_bg',
    label: '배경',
  },
  NICKNAME: {
    type: 'skin_user_nickname',
    label: '닉네임',
  },
  COMMENT: {
    type: 'skin_comment_card',
    label: '댓글',
  },
  PROFILE_BUTTON: {
    type: 'skin_profile_btn',
    label: '팔로우 버튼',
  },
};

const UNIVERSAL_REASON_TYPES = {
  UNREGISTER_USER: 'close_user',
  REVIEW: 'low_review',
  REQUEST_CATEGORY: 'req_category',
  APP_REVIEW: 'app_review',
  STORY_AD_REVIEW: 'story_ad_review',
};

const AD_STATUSES = {
  LOADING: 0,
  SUCCESS: 1,
  FAILED: 2,
};

const AUTH_STATUSES = {
  LOADING: 0,
  SUCCESS: 1,
  FAILED: 2,
};

const TAB_INDEXES = {
  HOME: 0,
  ORIGINAL: 1,
  SEARCH: 2,
  LIBRARY: 3,
  STUDIO: 4,
};

const WEB_TAB_INDEXES = {
  HOME: 0,
  SEARCH: 1,
  LIBRARY: 2,
  STUDIO: 3,
};

const PAYMENT_VENDORS = {
  STANDARD: 'S',
  APPLE: 'A',
};

const PAYMENT_TYPES = {
  COIN: 'C',
  BALLOON: 'PT',
};

const AD_TYPES = {
  REWARD: 'reward',
  INTERSTITIAL: 'interstitial',
  FBINTERSTITIAL: 'fbinterstitial',
  INTERSTITIAL_BACKFILL: 'interstitial_backfill',
  CHEER_REWARD: 'cheer_reward',
  STORY_AD_FULL: 'story_ad_full',
};

const AD_MEDIATION_TYPES = {
  MOPUB: 'mopub',
  ADX: 'adx',
};

const REMOTE_CONFIG_KEYS = {
  SHOW_AD_TAP_COUNT: 'SHOW_AD_TAP_COUNT',
  EPISODE_AD_ORDER: 'EPISODE_AD_ORDER',
  CERT_POPUP_DURATION: 'CERT_POPUP_DURATION',
  INDUCE_OFFERWALL_TYPE: 'INDUCE_OFFERWALL_TYPE',
  BULK_PURCHASE_COUNT: 'BULK_PURCHASE_COUNT',
};

const COLOR = {
  TEAL: '#20a2ae',
  BLACK: '#1d2127',
  WHITE: '#ffffff',
  LIGHT_GRAY: '#f2f2f2',
};

const BALLOON_TYPES = {
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold',
  DONATION: 'donation',
};

const CHEER_TYPES = {
  AD: 'AD',
  RA: 'RA',
};

const USER_SETTINGS = {
  REPLY: 'new_reply_push_status',
  EPISODE: 'new_episode_push_status',
  FOLLOWING: 'following_update_push_status',
};

const STORY_AD_TYPES = {
  LIST: 'LIST',
  FULL: 'FULL',
};

const NOTIFICATION_TYPES = {
  ENABLE: 'enable',
  PARTIAL_ENABLE: 'partial_enable',
  DISABLE: 'disable',
};

const RESTRICTION_STATUS = {
  NORMAL: {
    value: 'normal',
    label: '정상',
  },
  CAU: {
    value: 'cau',
    label: '주의',
  },
  WARN_1: {
    value: 'warn1',
    label: '1차 경고',
  },
  WARN_2: {
    value: 'warn2',
    label: '2차 경고',
  },
  WARN_3: {
    value: 'warn3',
    label: '3차 경고',
  },
  WARN_4: {
    value: 'warn4',
    label: '4차 경고',
  },
  EXC: {
    value: 'exc',
    label: '정지',
  },
};

const STORY_AD_EVENT_CHECK_TYPES = {
  EASY_ENTRY: 'easy_entry',
};

const VIEWER_OPTIONS = {
  FONT_SIZE: 'fontSize',
  AUTO_PLAY_SPEED: 'autoPlaySpeed',
  THEME: 'theme',
};

const THEME_GROUPS = {
  tap_novel: [
    {
      name: 'white',
      backgroundColor: '#ffffff',
      textColor: '#1c1c1c',
    },
    {
      name: 'light_gray',
      backgroundColor: '#A0A0A0',
      textColor: '#29292E',
    },
    {
      name: 'ivory',
      backgroundColor: '#e2ddce',
      textColor: '#333333',
    },
    {
      name: 'gray',
      backgroundColor: '#484744',
      textColor: '#CACACA',
    },
    {
      name: 'black',
      backgroundColor: '#000000',
      textColor: '#CACACA',
    },
  ],
};

const THEMES = {
  TAP_NOVEL: 'tap_novel',
  IKNOW: 'iknow',
  IKNOW_STANDARD: 'iknow_standard',
};

const VOUCHER_TYPES = {
  AB_F_S: 'AB_F_S',
  ABP_F_P: 'ABP_F_P',
  ABP_F_R: 'ABP_F_R',
  DBP_F_D: 'DBP_F_D',
  DBP_F_SA: 'DBP_F_SA',
  DBN_F_SA: 'DBN_F_SA',
  DBP_F_EP: 'DBP_F_EP',
  DBP_F_ER: 'DBP_F_ER',
  DBP_F_EPS: 'DBP_F_EPS',
  ALL: 'ALL',
  ALL_STORY_ADS: 'ALL_STORY_ADS',
  ALL_DONATION: 'ALL_DONATION',
  ALL_REWARD: 'ALL_REWARD',
  ALL_PAYMENT: 'ALL_PAYMENT',
};

const VOUCHER_RECOMMENDATION_TYPES = {
  PAYMENT: 'PAYMENT',
  REWARD: 'REWARD',
  STORY_ADS: 'STORY_ADS',
  DONATION: 'DONATION',
  EPISODE_PREVIEW: 'EPISODE_PREVIEW',
  EPISODE_RENTAL: 'EPISODE_RENTAL',
  EPISODE_POSSESSION: 'EPISODE_POSSESSION',
};

const GENDER = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
};

const CHECK_SIGN_KEY = {
  NICKNAME: 'nickname',
  EMAIL: 'signup_by_email',
  facebook: 'signup_by_facebook',
  kakao: 'signup_by_kakao',
  naver: 'signup_by_naver',
  google: 'signup_by_google',
  apple: 'signup_by_apple',
};

const BULK_PURCHASE_TYPE = {
  waitfree: 'waitfree',
  showAd: 'show_ad',
  remove_ad: 'remove_ad',
  rental: 'rental',
  possession: 'possession',
  preview: 'preview',
};

export default {
  SECTION_TYPES,
  PLATFORMS,
  GENRES,
  STORY_TYPES,
  STORY_SALE_TYPES,
  PURCHASE_TYPES,
  EPISODE_STATUSES,
  MARKET_ITEM_TYPES,
  UNIVERSAL_REASON_TYPES,
  AD_STATUSES,
  TAB_INDEXES,
  WEB_TAB_INDEXES,
  PAYMENT_VENDORS,
  PAYMENT_TYPES,
  AD_TYPES,
  AUTH_STATUSES,
  AD_MEDIATION_TYPES,
  REMOTE_CONFIG_KEYS,
  COLOR,
  BALLOON_TYPES,
  CHEER_TYPES,
  USER_SETTINGS,
  STORY_AD_TYPES,
  NOTIFICATION_TYPES,
  RESTRICTION_STATUS,
  STORY_AD_EVENT_CHECK_TYPES,
  VIEWER_OPTIONS,
  THEME_GROUPS,
  THEMES,
  VOUCHER_TYPES,
  VOUCHER_RECOMMENDATION_TYPES,
  GENDER,
  CHECK_SIGN_KEY,
  BULK_PURCHASE_TYPE,
};



// WEBPACK FOOTER //
// ./src/app/utils/constants.js